export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.origin}/`,
  },
};

export const getHeaders = () => {
  return {
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  }
}

export const getTextLogo = () => {
  switch (window.location.host) {
    case 'sport22.net':
      return 'BET777';
    case 'sportgamble.net':
      return '<span><b>sport</b> <b>gamble</b></span>';
    default:
      return '<span>365</span>';
  }
}

export const getLogo = () => {
  switch (window.location.host) {
    case '365ecco365.net':
    case 'localhost:8080':
      return 'img/ebet.png';
    case '365euro365.com':
      return 'img/logo_eurobet.svg';
    default:
      return null;
  }
}

export const enablePrint = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return true;
    default:
      return false;
  }
}

export const getTitle = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return 'OSWIN21';
    case '365ecco365.net':
      return 'ecco';
    default:
      return '365';
  }
}


export const enableTableTimeline = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return true;
    default:
      return false;
  }
}